import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { Play, Pause } from 'lucide-react';
import { usePauseJobs } from '../../hooks/admin/use-admin-jobs';

export function PauseResumeButton() {
  const { paused, toggle, isLoading } = usePauseJobs();

  return (
    <Button
      onClick={toggle}
      disabled={isLoading}
      variant="contained"
      color={paused ? 'success' : 'warning'}
      startIcon={
        isLoading ? (
          <CircularProgress size={16} color="inherit" />
        ) : paused ? (
          <Play size={16} />
        ) : (
          <Pause size={16} />
        )
      }
    >
      {paused ? 'Resume Jobs' : 'Pause Jobs'}
    </Button>
  );
}
